class ThemeGtm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrackingClicks = this.handleTrackingClicks.bind(this)
    this.handleFormTracking = this.handleFormTracking.bind(this)

    this.listeners.add(document, 'click', this.handleTrackingClicks)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.KLAVIYO.FORM_SUBMITTED,
      this.handleFormTracking,
    )
  }

  handleTrackingClicks (event) {
    const clickedGtmEl = event.target.closest('[data-theme-gtm-el]')

    if (!clickedGtmEl) return

    if (clickedGtmEl.dataset.themeGtmEl === 'basic_event') {
      this.handleBasicEventClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'navigation') {
      this.handleNavigationClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'home_content') {
      this.handleHomeContentClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'filter') {
      this.handleFilterClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'similar_products') {
      this.handleSimilarProductsClick(clickedGtmEl)
    }
    if (
      clickedGtmEl.dataset.themeGtmEl === 'content_image_plp_desktop' &&
      window.innerWidth >= 768
    ) {
      this.handleContentImageClick(clickedGtmEl)
    }
    if (
      clickedGtmEl.dataset.themeGtmEl === 'content_image_plp_mobile' &&
      window.innerWidth < 768
    ) {
      this.handleContentImageClick(clickedGtmEl)
    }
    if (
      clickedGtmEl.dataset.themeGtmEl === 'content_video_plp_desktop' &&
      window.innerWidth >= 768
    ) {
      this.handleContentVideoClick(clickedGtmEl)
    }
    if (
      clickedGtmEl.dataset.themeGtmEl === 'content_video_plp_mobile' &&
      window.innerWidth < 768
    ) {
      this.handleContentVideoClick(clickedGtmEl)
    }
  }

  handleBasicEventClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleNavigationClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: `${clickedGtmEl.dataset.themeGtmEvent}_navigation`,
        nav_used: clickedGtmEl.dataset.themeGtmUsed,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleHomeContentClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'home_content',
        content_block: clickedGtmEl.dataset.themeGtmBlock,
        content_detail: clickedGtmEl.dataset.themeGtmDetail,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleFilterClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'filter_click',
        [`filter_${clickedGtmEl.dataset.themeGtmKey}`]:
          clickedGtmEl.dataset.themeGtmValue,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleSimilarProductsClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'similar_products',
        position: clickedGtmEl.dataset.themeGtmIndex,
        product_handle: clickedGtmEl.dataset.themeGtmHandle,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleContentImageClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'content_image_plp',
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleContentVideoClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'content_video_plp',
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleFormTracking (e) {
    const { customerEmail } = e.detail

    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'dl_subscribe',
        lead_type: 'email',
        user_properties: {
          customer_email: `${customerEmail}`,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }
}

if (!customElements.get('theme-gtm')) {
  customElements.define('theme-gtm', ThemeGtm)
}
